import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

import { SERVER_API_URL } from 'src/app/app.constants';
import { createRequestOption } from 'src/app/shared/util/request-util';
import { ILanguage } from 'src/app/shared/model/language.model';

type EntityResponseType = HttpResponse<ILanguage>;
type EntityArrayResponseType = HttpResponse<ILanguage[]>;

@Injectable({ providedIn: 'root' })
export class LanguageService {
    private resourceUrl = SERVER_API_URL + 'api/languages';
    private resourceOpenUrl = SERVER_API_URL + 'api/open/languages';
    private allLanuagesResourceUrl = SERVER_API_URL + 'api/all-languages';
    private spotAllLanuagesResourceUrl = SERVER_API_URL + 'api/spot-all-languages';


    constructor(private http: HttpClient) {}

    create(language: ILanguage): Observable<EntityResponseType> {
        return this.http.post<ILanguage>(this.resourceUrl, language, { observe: 'response' });
    }

    update(language: ILanguage): Observable<EntityResponseType> {
        return this.http.put<ILanguage>(this.resourceUrl, language, { observe: 'response' });
    }

    find(id: number): Observable<EntityResponseType> {
        return this.http.get<ILanguage>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }

    query(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http.get<ILanguage[]>(this.resourceUrl, { params: options, observe: 'response' });
    }

    queryGetLanguages(): Observable<EntityArrayResponseType> {
        return this.http.get<ILanguage[]>(this.allLanuagesResourceUrl, { observe: 'response' });
    }

    queryOpen(): Observable<EntityArrayResponseType> {
        return this.http.get<ILanguage[]>(this.resourceOpenUrl, { observe: 'response' });
    }
    spotQueryGetLanguages(): Observable<EntityArrayResponseType> {
        return this.http.get<ILanguage[]>(this.spotAllLanuagesResourceUrl, { observe: 'response' });
    }

    delete(id: number): Observable<HttpResponse<any>> {
        return this.http.delete<any>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }
}
